import { fetchHomeHealthStatus } from "model/HomePageModel";
import { getJobRequiredList } from "model/JobRequiredModel";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const CurrentApiStatus = () => {
    const [homeHealthData, setHomeHealthData] = useState("");
    const [loading, setLoading] = useState(false);

     useEffect(() => {
        getHomeHealth();
      }, []);
    
      const getHomeHealth = async () => {
        setLoading(true);
        let response = await fetchHomeHealthStatus([]);
        let requiredData = response;
    
        if (response) {
            setHomeHealthData(requiredData);
          setLoading(false);
        } else {
            setHomeHealthData([]);
          setLoading(false);
        }
      };
  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <div className="text-center p-4">
        <h1 className={`display-4 ${homeHealthData?.status=='Healthy' ? 'text-success'  : 'text-danger'}`}>{`${homeHealthData?.status=='Healthy' ? '200'  : '503'}`}</h1>
        <h3 className="mb-3">{`${homeHealthData?.status=='Healthy' ? 'Server Response Perfectly Work'  : 'An unexpected error occurred'}`}</h3>
        <p className="text-muted mb-4">
          {homeHealthData?.status}.
        </p>

        <Link to="/login" className="btn btn-primary">
          Go to Login
        </Link>
      </div>
    </div>
  );
};

export default CurrentApiStatus;
